import { FrontmatterReadView } from "@promptlayer/ui";
import React from "react";

import type {
  SkillFrontmatterEntry,
  SkillFrontmatterEntryGroup,
} from "../../utils/skill-frontmatter";

import { FrontmatterEditForm } from "./FrontmatterEditForm";
import type { FrontmatterFormState } from "./utils";

interface FrontmatterPanelBodyProps {
  isEditing: boolean;
  draftState: FrontmatterFormState;
  onDraftChange: React.Dispatch<React.SetStateAction<FrontmatterFormState>>;
  onApply: () => void;
  onCancel: () => void;
  topLevelEntries: SkillFrontmatterEntry[];
  groups: SkillFrontmatterEntryGroup[];
  hasEntries: boolean;
}

export const FrontmatterPanelBody = ({
  isEditing,
  draftState,
  onDraftChange,
  onApply,
  onCancel,
  topLevelEntries,
  groups,
  hasEntries,
}: FrontmatterPanelBodyProps) => {
  const readView = hasEntries ? (
    <FrontmatterReadView topLevelEntries={topLevelEntries} groups={groups} />
  ) : (
    <div className="px-3 pb-2 text-xs text-gray-500">
      This frontmatter contains YAML that is not shown as key/value fields. Use metadata editing to
      modify it.
    </div>
  );

  return (
    <div className="overflow-hidden">
      <div
        className={`grid overflow-hidden transition-[grid-template-rows,opacity] duration-200 ease-out motion-reduce:transition-none ${
          isEditing ? "grid-rows-[0fr] opacity-0" : "grid-rows-[1fr] opacity-100"
        }`}
        aria-hidden={isEditing}
      >
        <div className={`min-h-0 overflow-hidden ${isEditing ? "pointer-events-none" : ""}`}>
          {readView}
        </div>
      </div>
      <div
        className={`grid overflow-hidden transition-[grid-template-rows,opacity] duration-200 ease-out motion-reduce:transition-none ${
          isEditing ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
        }`}
        aria-hidden={!isEditing}
      >
        <fieldset
          disabled={!isEditing}
          className={`min-h-0 overflow-hidden border-0 p-0 ${!isEditing ? "pointer-events-none" : ""}`}
        >
          <FrontmatterEditForm
            draftState={draftState}
            onDraftChange={onDraftChange}
            onApply={onApply}
            onCancel={onCancel}
          />
        </fieldset>
      </div>
    </div>
  );
};
